import React from 'react';

export const IconLabel: React.FunctionComponent<{icon: JSX.Element, label: string}> = ({icon, label}) => {
  return (
    <div className="d-flex justify-content-start align-items-center gap-1 gap-md-2">
      <div className="icon">{icon}</div>
      <div className="label">{label}</div>
    </div>
  );
}